import {
  isStudioPricingReferrer,
  STUDIO_PRICING_REFERRER,
  STUDIO_REFERRER,
} from 'src/constants/studioFtux';

// Re-exported so the onboarding funnel keeps one import for referrer handling; the
// values themselves live with the other cross-stack Studio constants.
export { isStudioPricingReferrer, STUDIO_PRICING_REFERRER, STUDIO_REFERRER };

/** Gate for the Studio funnel — never compare `referrer` to a single value. */
export const isStudioReferrer = (referrer?: string): boolean =>
  referrer === STUDIO_REFERRER || referrer === STUDIO_PRICING_REFERRER;

/**
 * Referrer value to put in a URL the funnel returns to. The email funnel keeps the
 * current URL (and its referrer) throughout, so this is only needed for the Google
 * OAuth hop, which rebuilds the URL from customState. Normalizes rather than
 * passing through, so an unexpected value can never reach a URL.
 */
export const resolveStudioReferrer = (referrer?: string): string =>
  isStudioPricingReferrer(referrer) ? STUDIO_PRICING_REFERRER : STUDIO_REFERRER;

/** Skips Studio get-started when resuming from an existing workspace session. */
export const STUDIO_STEP_PARAM = 'studio_step';
export const STUDIO_STEP_EMAIL_VERIFICATION = 'email-verification';
export const STUDIO_STEP_WORKSPACE_SETUP = 'workspace-setup';

/** Query flag marking the Google OAuth return after Studio workspace creation. */
export const STUDIO_POST_CREATE_PARAM = 'studio_post_create';
export const STUDIO_POST_CREATE_VALUE = '1';
export const STUDIO_POST_CREATE_PORTAL_HEADER_PARAM = 'portal_header';
export const STUDIO_POST_CREATE_PORTAL_URL_PARAM = 'portal_url';
